import React from 'react';
import { Alert } from 'antd';
import Loader from 'src/components/loader.component';
import { NumericFormat } from 'react-number-format';


const Kpis = (props) => {
    const availableCredit = props?.creditData;
    const usedCredit = props?.usedCredit;
    const handleFilterChange = props?.handleFilterChange;
    const days = props?.days;
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">

            <div className="col-span-1 !border-cardBorder border p-3.5 rounded-md">
                {availableCredit?.loading && <div className="kpis-loading">
                    <Loader />
                </div>}
                {availableCredit?.error &&
                    <div className="kpis-error" style={{ padding: '20px' }}>
                        <Alert message="error" description={availableCredit?.error} type="error" showIcon />
                    </div>}
                {!availableCredit?.loading &&
                    <div>
                        <p className="text-paraColor text-base font-medium">Available Credit</p>
                        <NumericFormat
                            value={availableCredit?.data?.availableCredit || 0}
                            displayType="text"
                            thousandSeparator
                            decimalScale={4}
                            className="text-md text-subTextColor font-semibold"
                        />
                    </div>
                }
            </div>

            {/* Used Credit (larger card) */}
            <div className="col-span-1 md:col-span-2 !border-cardBorder border p-3.5 rounded-md">

                <div className="md:flex justify-between items-center md:space-y-0 space-y-4 mb-2">
                    {usedCredit.loading && <div className="kpis-loading">
                        <Loader />
                    </div>}
                    {usedCredit.error &&
                        <div className="kpis-error" style={{ padding: '20px' }}>
                            <Alert message="error" description={usedCredit.error} type="error" showIcon />
                        </div>}
                    {!usedCredit.loading && <div>
                        <span className="text-paraColor text-base font-medium">Used Credit</span>
                        <div>
                            <NumericFormat
                                value={usedCredit?.data || 0}
                                displayType="text"
                                thousandSeparator
                                decimalScale={4}
                                className="text-md text-subTextColor font-semibold"
                            />
                        </div>
                    </div>}
                    <div className="md:flex block items-start justify-between md:justify-end">
                        <div className="range-buttons flex md:block border border-StrokeColor rounded-md">
                            <button
                                className={days === 1 ? "bg-primaryColor text-lightDark px-4 py-2 text-base rounded-l-md w-full md:w-auto" : "text-base text-subTextColor px-4 py-2 rounded-l-md w-full md:w-auto"}
                                onClick={() => handleFilterChange(1)}
                            >
                                1 Day
                            </button>
                            <button
                                className={days === 7 ? "bg-primaryColor text-lightDark px-4 py-2 text-base w-full md:w-auto" : "text-base text-subTextColor px-4 py-2 w-full md:w-auto"}
                                onClick={() => handleFilterChange(7)}
                            >
                                7 Days
                            </button>
                            <button
                                className={days === 30 ? "bg-primaryColor text-lightDark px-4 py-2 text-base rounded-r-md w-full md:w-auto" : "text-base text-subTextColor px-4 py-2 rounded-r-md w-full md:w-auto"}
                                onClick={() => handleFilterChange(30)}
                            >
                                30 Days
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Kpis;
